module.exports = __webpack_public_path__ + "img/individual.e9e7138e.svg";